<!-- <div class="topbar">
</div> -->
<div
  *ngIf="company"
  class="topbar__company">
  <img
    class="companyImage"
    src="../../assets/images/settings/company.svg" />
  <span>{{ company.name }} ({{ company.id }})</span>
  <img
    class="closeImage"
    src="../../assets/images/settings/close.svg"
    (click)="resetCompany()" />
</div>

<dcc-entity-search
  [clearTextOnSelect]="true"
  [company]="company"
  (entity)="onEntitySelected($event)"></dcc-entity-search>

<input
  placeholder="Search Setting"
  [inputFormatter]="formatter"
  [ngbTypeahead]="searchSettings"
  [resultFormatter]="formatter"
  [(ngModel)]="settingFilter"
  (selectItem)="onSelectItem($event)" />
